const actors = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export default actors;



// WEBPACK FOOTER //
// ./src/reducers/actors.js